module.exports = __webpack_public_path__ + "static/media/shared_pool.486c37e1.svg";